import React, { useId } from 'react';

// MUI Components
import { Box, Dialog, DialogContent, IconButton, Typography } from '@mui/material';

// Icons
import { CloseModalIcon } from '~/assets/images';

import OlcModalFooter from '~/components/General/OlcModalFooter';

// Styles
import './styles.scss';

const OlcFormModal = ({
  open,
  onClose,
  title,
  subtitle,
  children,
  footer,
  className = '',
  contentClassName = '',
  footerClassName = '',
  dialogProps = {},
}) => {
  const generatedTitleId = useId();
  const titleId = `olc-form-modal-${generatedTitleId.replace(/:/g, '')}`;

  return (
    <Dialog
      {...dialogProps}
      open={open}
      onClose={onClose}
      aria-labelledby={titleId}
      className={`olcModal olcFormModal ${className}`.trim()}
    >
      <DialogContent className={`modalContent olcFormModalContent ${contentClassName}`.trim()}>
        <Box className="modalHeader">
          <Box>
            <Typography id={titleId} className="title">
              {title}
            </Typography>
            {subtitle ? <Typography className="subTitle">{subtitle}</Typography> : null}
          </Box>
          <IconButton
            aria-label={`Close ${title} modal`}
            onClick={onClose}
            className="crossIcon"
            disableRipple
            disableFocusRipple
            disableTouchRipple
          >
            <img src={CloseModalIcon} alt="close" />
          </IconButton>
        </Box>
        <Box className="olcFormModalBody">{children}</Box>
        {footer ? (
          <OlcModalFooter className={`olcFormModalFooter ${footerClassName}`.trim()}>
            {footer}
          </OlcModalFooter>
        ) : null}
      </DialogContent>
    </Dialog>
  );
};

export default OlcFormModal;
